import {Component, Input, OnInit} from '@angular/core';
import {PropertyMappingModel} from "web-shared";
import {BaseModalComponent, CONSTANTS} from "common-shared";
import {TaskSelectorModel} from "web-shared";
import {Subject} from "rxjs";

@Component({
  selector: 'mes-task-selector-edit-modal',
  templateUrl: './task-selector-edit-modal.component.html',
  styles: [
  ]
})
export class TaskSelectorEditModalComponent extends BaseModalComponent implements OnInit {
  @Input() taskSelector: TaskSelectorModel;
  @Input() mode: 'edit' | 'add' | '' = "edit";
  @Input() allowAdd: boolean = true;
  wasValidated$: Subject<boolean> = new Subject<boolean>();
  readonly: boolean;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  submit(action: 'add' | 'change') {
    this.wasValidated$.next(true);
    if (this.taskSelector.isValid()) {
      this.close(this.taskSelector, action);
    }
  }

  delete(withInstructions: boolean = false) {
    this.close(this.taskSelector, withInstructions ? 'deleteWithInstructions' : 'delete');
  }

  onPropertyMappingAdded($event: PropertyMappingModel) {
    $event.MandatoryClv = CONSTANTS.Mandatory.Hidden;
  }

  onPropertyMappingRemoved($event: PropertyMappingModel) {
    this.taskSelector.Mappings = this.taskSelector.Mappings.filter(value => value.Id !== $event.Id);
  }

  onPropertyMappingChanged($event: PropertyMappingModel[]) {
    this.taskSelector.Mappings = [...$event];
  }
}
